import type {
	IndicatorComparisonPayload,
	IndicatorPeriodPayload,
} from '@Application/Indicators/Actions/indicatorPeriodPayload';

export type CostIndicatorsPayload = {
	queryKey: string;
	period: IndicatorPeriodPayload;
	total: IndicatorComparisonPayload;
	callCount: number | null;
	unpricedCallCount: number | null;
	hasActivity: boolean;
	hasUnpricedCalls: boolean;
	isEntirelyUnpriced: boolean;
};

export type CostIndicatorsFetchedAction = {
	type: 'COST_INDICATORS_FETCHED';
	payload: CostIndicatorsPayload;
};

export default (payload: CostIndicatorsPayload): CostIndicatorsFetchedAction => ({
	type: 'COST_INDICATORS_FETCHED',
	payload,
});
